"use client"

import { Avatar, AvatarFallback, AvatarImage } from '../../../shared/components/ui/avatar'
import { TypographyH3, TypographyP, TypographySmall } from '../../../shared/components/ui/typography'
import { cn, shortenName } from '../../../shared/lib/utils'
import React from 'react'
import { useActiveChat } from '../context/active-chat-context'
import { ChatItemProps } from '../types'

function ChatItem(props: ChatItemProps) {

    const [firstName, lastName] = props.username.split(' ')
    const { setActiveChat, handleShowChatDetails } = useActiveChat()
    const isActive = props.id === useActiveChat().activeChat?.id

    return (
        <div 
            className={cn('w-full flex items-center gap-2 cursor-pointer py-5 px-5', {
                'bg-completed/10': isActive
            })}
            onClick={() => {
                handleShowChatDetails(true)
                setActiveChat(props)       
            } }
        >
            <Avatar>
                <AvatarFallback>{shortenName(firstName, lastName)}</AvatarFallback>
                <AvatarImage src="https://randomuser.me/api/port" />
            </Avatar>
            <div className="space-y-1.5">
                <TypographyH3 className='text-lg font-semibold leading-none'>{props.username}</TypographyH3>
                <TypographyP className='text-muted-foreground leading-none text-sm'>{props.message}</ TypographyP>
            </div>
            <TypographySmall className='self-start text-muted-foreground/60 text-xs'>{props.time}</TypographySmall>
        </div>
    )
}

export default ChatItem